"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserSegmentationData = exports.UserSegmentationDataProvider = exports.UserSegmentationDataContext = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _react = require("react");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const UserSegmentationDataContext = exports.UserSegmentationDataContext = /*#__PURE__*/(0, _react.createContext)({
  consultantNumber: undefined,
  customerCategory: undefined,
  customerTypeId: undefined,
  loading: true,
  visitorSegment: undefined,
  atpClusterId: undefined
});
/**
 * Provider for User Segmentation data.
 * It fetches ATP Cluster ID and Customer Type ID and Visitor Segment for authenticated customers.
 * If you provide `atpClusterId` prop, fetching ATP Cluster ID will be disabled.
 * If you provide `customerTypeId`, fetching of customerInfo will be disabled.
 *
 * @param atpClusterId - ATP Cluster ID to use instead of fetching it.
 * @param customerTypeId - Customer Type ID to use instead of fetching it.
 * @param visitorSegment - Visitor Segment to use instead of fetching it.
 * @param disableFetching - If true, fetching of ATP Cluster ID and Customer Type ID will be disabled.
 **/
const UserSegmentationDataProvider = ({
  children,
  atpClusterId: atpClusterIdProp,
  customerTypeId: customerTypeIdProp,
  visitorSegment: visitorSegmentProp,
  disableFetching
}) => {
  const enabledGetAtpClusterId = atpClusterIdProp == null && !disableFetching;
  const enabledGetCustomerInfo = customerTypeIdProp == null && !disableFetching;
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    atpClusterId,
    error: atpClusterIdError,
    loading: atpClusterIdLoading
  } = (0, _hooks.useGetAtpClusterId)({
    customerId,
    enabled: enabledGetAtpClusterId,
    tenant
  });
  const {
    consultantNumber,
    customerCategory,
    customerTypeId,
    error: customerInfoError,
    loading: customerInfoLoading,
    visitorSegment
  } = (0, _hooks.useGetCustomerInfo)({
    customerId,
    enabled: enabledGetCustomerInfo
  });
  const data = (0, _react.useMemo)(() => ({
    atpClusterId: atpClusterIdProp ?? atpClusterId,
    consultantNumber,
    customerCategory,
    customerTypeId: customerTypeIdProp ?? customerTypeId,
    visitorSegment: visitorSegmentProp ?? visitorSegment,
    loading: atpClusterIdLoading || customerInfoLoading,
    error: atpClusterIdError ?? customerInfoError
  }), [atpClusterIdProp, atpClusterId, consultantNumber, customerCategory, customerTypeIdProp, customerTypeId, visitorSegmentProp, visitorSegment, atpClusterIdLoading, customerInfoLoading, atpClusterIdError, customerInfoError]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(UserSegmentationDataContext.Provider, {
    value: data,
    children: children
  });
};
exports.UserSegmentationDataProvider = UserSegmentationDataProvider;
const useUserSegmentationData = () => (0, _react.useContext)(UserSegmentationDataContext);
exports.useUserSegmentationData = useUserSegmentationData;
